import {
	SET_ICEPACKS,
	SET_IS_ICEPACKS_LOADING,
	SET_ICEPACKS_FILLERS,
	SET_IS_ICEPACKS_FILLERS_LOADING,
	SET_ICEPACKS_STATES,
	SET_IS_ICEPACKS_STATES_LOADING,
	SET_MODES,
	SET_IS_MODES_LOADING,
	SET_ICEPACK_FILLED_INFO,
	SET_IS_ICEPACK_FILLED_INFO_LOADING,
	SET_IS_ICEPACK_FILLED_CREATING,
	SET_IS_ICEPACK_FILLED_UPDATING,
	SET_IS_ICEPACK_FILLED_DELETING,
	RESET_STATE,
} from './actions';

export const initialState = {
	icepacks: [],
	isIcepacksLoading: false,
	icepacksFillers: [],
	isIcepacksFillersLoading: false,
	icepacksStates: [],
	isIcepacksStatesLoading: false,
	modes: [],
	isModesLoading: false,
	icepackFilledInfo: null,
	isIcepackFilledInfoLoading: false,
	isIcepackFilledCreating: false,
	isIcepackFilledUpdating: false,
	isIcepackFilledDeleting: false,
};

const icepackFilledModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ICEPACKS:
			return { ...state, icepacks: payload };
		case SET_IS_ICEPACKS_LOADING:
			return { ...state, isIcepacksLoading: payload };
		case SET_ICEPACKS_FILLERS:
			return { ...state, icepacksFillers: payload };
		case SET_IS_ICEPACKS_FILLERS_LOADING:
			return { ...state, isIcepacksFillersLoading: payload };
		case SET_ICEPACKS_STATES:
			return { ...state, icepacksStates: payload };
		case SET_IS_ICEPACKS_STATES_LOADING:
			return { ...state, isIcepacksStatesLoading: payload };
		case SET_MODES:
			return { ...state, modes: payload };
		case SET_IS_MODES_LOADING:
			return { ...state, isModesLoading: payload };
		case SET_ICEPACK_FILLED_INFO:
			return { ...state, icepackFilledInfo: payload };
		case SET_IS_ICEPACK_FILLED_INFO_LOADING:
			return { ...state, isIcepackFilledInfoLoading: payload };
		case SET_IS_ICEPACK_FILLED_CREATING:
			return { ...state, isIcepackFilledCreating: payload };
		case SET_IS_ICEPACK_FILLED_UPDATING:
			return { ...state, isIcepackFilledUpdating: payload };
		case SET_IS_ICEPACK_FILLED_DELETING:
			return { ...state, isIcepackFilledDeleting: payload };
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default icepackFilledModalReducer;
